module.exports = __webpack_public_path__ + "static/media/main_paper_2.a95cfc5c.png";